import { setAuthToken } from '../utils/authSession';
import { ApolloLink } from 'apollo-link';

export const jwtHeadersAfterware = new ApolloLink((operation, forward) => {
    return forward(operation).map(response => {
        const context = operation.getContext();
        const {
            response: { headers }
        } = context;

        if (headers) {
            const token = headers.get('x-token');
            const storedToken = localStorage.getItem('token');

            if (token && token !== storedToken) {
                setAuthToken(token);
            }
        }
        return response;
    });
});
